import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

//import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import VEHICLES_EN from './locales/en/vehicles.json';
import TRIMS_EN from './locales/en/trims.json';
import OPTIONS_EN from './locales/en/options.json';
import PACKAGES_EN from './locales/en/packages.json';
import CONNECTIVITY_EN from './locales/en/connectivity.json';
import COLOURS_EN from './locales/en/colours.json';
import WHEELS_EN from './locales/en/wheels.json';
import ACCESSORIES_EN from './locales/en/accessories.json';
import PROTECTION_EN from './locales/en/protection.json';
import PAYMENTS_EN from './locales/en/payments.json';
import SUMMARY_EN from './locales/en/summary.json';
import EVGRID_EN from './locales/en/evGrid.json';
import GENERAL_EN from './locales/en/general.json';

import VEHICLES_FR from './locales/fr/vehicles.json';
import TRIMS_FR from './locales/fr/trims.json';
import OPTIONS_FR from './locales/fr/options.json';
import PACKAGES_FR from './locales/fr/packages.json';
import CONNECTIVITY_FR from './locales/en/connectivity.json';
import COLOURS_FR from './locales/fr/colours.json';
import WHEELS_FR from './locales/fr/wheels.json';
import ACCESSORIES_FR from './locales/fr/accessories.json';
import PROTECTION_FR from './locales/fr/protection.json';
import PAYMENTS_FR from './locales/fr/payments.json';
import SUMMARY_FR from './locales/fr/summary.json';
import EVGRID_FR from './locales/fr/evGrid.json';
import GENERAL_FR from './locales/fr/general.json';

const languages = ['en', 'fr'];
const resources = {
          en: {
            general: GENERAL_EN,
            vehicles: VEHICLES_EN,
            trims: TRIMS_EN,
            options: OPTIONS_EN,
            connectivity: CONNECTIVITY_EN,
            packages: PACKAGES_EN,
            colours: COLOURS_EN,
            wheels: WHEELS_EN,
            accessories: ACCESSORIES_EN,
            protection: PROTECTION_EN,
            payments: PAYMENTS_EN,
            summary: SUMMARY_EN,
			evGrid: EVGRID_EN
          },
          fr: {
            general: GENERAL_FR,
            vehicles: VEHICLES_FR,
            trims: TRIMS_FR,
            options: OPTIONS_FR,
            packages: PACKAGES_FR,
            connectivity: CONNECTIVITY_FR,
            colours: COLOURS_FR,
            wheels: WHEELS_FR,
            accessories: ACCESSORIES_FR,
            protection: PROTECTION_FR,
            payments: PAYMENTS_FR,
            summary: SUMMARY_FR,
			evGrid: EVGRID_FR
          }
        }
console.log(resources);


i18n
  //.use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    lng: document.querySelector('meta[name="data-language"]').content, //"en",
    fallbackLng: "en",
    debug: true,
    whitelist: languages,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'span', 'a'],
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
